import { render, staticRenderFns } from "./RsaConfigurazioneSpeseExtraEditComponent.vue?vue&type=template&id=2bd06609"
import script from "./RsaConfigurazioneSpeseExtraEditComponent.vue?vue&type=script&lang=js"
export * from "./RsaConfigurazioneSpeseExtraEditComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports